module.exports = __webpack_public_path__ + "img/header-weddingRingsMulticolor@2x.775a7ad.jpg";